import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { LoggingService, LogAppSection } from './logging.service';

declare const FB: any;

@Injectable()
export class FacebookService {
  appId = environment.facebookAppId;
  userId;

  script = document.createElement('script');
  loading = false;
  loaded = false;
  promises = [];
  accessToken = new Subject();

  constructor(private loggingService: LoggingService) {}

  getFacebook() {
    return new Promise((resolve, reject) => {
      if (this.loading) {
        this.promises.push(resolve);
        return;
      }
      if (this.loaded) {
        resolve();
        return;
      }
      this.loading = true;
      this.script.async = true;
      this.script.src = 'https://connect.facebook.net/en_US/sdk.js';
      this.script.onload = () => {
        FB.init({
          appId: this.appId,
          cookie: true,
          xfbml: false,
          version: 'v4.0',
        });
        FB.AppEvents.logPageView();

        resolve();
        this.promises.forEach(promise => promise());
        this.promises = [];
        this.loading = false;
        this.loaded = true;
      };
      document.getElementsByTagName('head')[0].appendChild(this.script);
    });
  }

  public getUserId = () => {
    return this.userId;
  };

  public setUserId = id => {
    if (!this.appId) {
      return null;
    }

    this.getFacebook().then(() => {
      FB.AppEvents.setUserID(id);
      this.userId = id;
      this.loggingService.log(`Facebook userId: ${id}`, {
        appSection: LogAppSection.Analytics,
      });
    });
  };

  public clearUserId = () => {
    if (!this.appId) {
      return null;
    }

    this.getFacebook().then(() => {
      FB.AppEvents.clearUserID();
      this.userId = '';
      this.loggingService.log('Facebook cleared user id', {
        appSection: LogAppSection.Analytics,
      });
    });
  };

  public login() {
    if (!this.appId) {
      return null;
    }
    this.getFacebook().then(() => {
      FB.login(resp => {
        if (resp.status === 'connected') {
          this.accessToken.next(resp.authResponse.accessToken);
        }
      });
    });
  }

}
